<template>
  <div class="bj-section">
    <div class="ubold-title" style="margin-bottom: 40px">在线充值</div>
    <div class="section" style="position: relative">
      <loading :loading="orderLoading" style="z-index: 11"></loading>
      <div class="title" style="margin-bottom: 30px">
        账户可用金额：
        <span class="price">{{ balance | balanceFilters }}</span> 元
      </div>

      <div class="bj-rows content-start" style="margin-bottom: 30px">
        <div class="name">充值金额：</div>
        <div class="label bj-rows content-start">
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="form.amount"
            placeholder="请输入充值金额"
            style="width: 200px"
            clearable
            @on-keyup="onAmountKeyUp"
            disabled
          />
          <div style="margin-left: 10px">元 充值最小金额1元</div>
        </div>
      </div>
<!--      <div class="bj-rows content-start" style="align-items: self-start">
        <div class="name">充值方式：</div>
        <div class="label bj-rows content-start">
          <div
            :class="['bj-rows cz-item', { actives: active === 1 }]"
            @click="active = 1"
          >
            <img
              class="cz-icon"
              :src="require('assets/image/cz-ali-icon.png')"
            />
            <div class="text" style="color: #219fdb">支付宝支付</div>
          </div>
          &lt;!&ndash;          <div&ndash;&gt;
          &lt;!&ndash;            :class="['row cz-item', { actives: active === 0 }]"&ndash;&gt;
          &lt;!&ndash;            style="margin-left: 20px"&ndash;&gt;
          &lt;!&ndash;            @click="active = 0"&ndash;&gt;
          &lt;!&ndash;          >&ndash;&gt;
          &lt;!&ndash;            <img&ndash;&gt;
          &lt;!&ndash;              class="wx-icon"&ndash;&gt;
          &lt;!&ndash;              :src="require('assets/image/cz-wechar-icon.png')"&ndash;&gt;
          &lt;!&ndash;            />&ndash;&gt;
          &lt;!&ndash;            <div class="text" style="color: #09bb07">微信支付</div>&ndash;&gt;
          &lt;!&ndash;          </div>&ndash;&gt;
        </div>
      </div>
      <Button
        class="bj-w120 bj-h45 bj-confirm-btn"
        type="primary"
        style="margin-top: 40px"
        @click="onConfirm"
        >确认充值</Button
      >-->
    </div>

    <div class="section back-info" style="margin-top: 20px">
      <img src="@/assets/image/bank-icon.png" alt="" class="bank-icon" />
      <div>
        <p class="back-title">银行汇款(对公)</p>
        <p>公司名称：域见未来（北京）科技有限公司</p>
        <p>银行账号：110934830510401</p>
        <p>开户银行：招商银行股份有限公司北京分行大运村支行</p>
        <p class="tips">
          汇款成功后请将汇款凭证及充值ID发送至service@domainfuture.cn，等待客服审核处理。
        </p>
      </div>
    </div>
    <!-- 微信二维码 -->
    <qrCodeModal
      :show.sync="qrCodeModalVisibility"
      :data="qrCodeData"
    ></qrCodeModal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { payRecharge } from "api/user.js";
import qrCodeModal from "components/back/qrCodeModal.vue";
import loading from "components/loading.vue";
import { WEBSOCKET_URL } from "@/utils/config";

export default {
  name: "recharge",
  components: {
    qrCodeModal,
    loading,
  },
  filters: {
    balanceFilters(value) {
      return !value
        ? ""
        : value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
  },
  computed: {
    ...mapState(["freezeAmount", "balance", "token"]),
  },
  data() {
    return {
      form: {
        amount: "",
      },
      active: -1,
      orderNo: "",
      qrCodeModalVisibility: false,
      qrCodeData: {
        qrCodeUrl: "",
        type: 0,
      },
      orderLoading: false,
    };
  },
  beforeDestroy() {
    // 销毁定时器
    if (this.webSocket) {
      this.sendMessage("stop");
    }
    this.webSocketResetInterval && clearInterval(this.webSocketResetInterval);
    this.heartInterval && clearInterval(this.heartInterval);
  },
  methods: {
    ...mapMutations(["MUT_AMOUNT"]),
    ...mapActions(["ACT_AMOUNT_INFO"]),
    onAmountKeyUp() {
      this.form.amount = this.form.amount.replace(/[^\d^\.]+/g, "");
    },
    // 重置提交
    async req_payRecharge() {
      try {
        if (!this.form.amount) {
          this.$Message.warning("请输入充值金额！");
          return;
        }
        if (this.money < 1) {
          this.$Message.warning("充值最小金额1元！");
          return;
        }
        if (this.active === -1) {
          this.$Message.warning("请选择充值方式！");
          return;
        }
        let params = {
          amount: this.form.amount,
          source: 2,
          type: this.active,
        };
        this.orderLoading = true;
        const { code, data, result } = await payRecharge(params);
        this.orderLoading = false;
        if (code == 200 && result) {
          this.qrCodeData.type = params.type;
          this.qrCodeData.qrCodeUrl = data.url;
          this.orderNo = data.orderNo;
          this.qrCodeModalVisibility = true;
          this.startSocket();
        }
      } catch (error) {
        this.orderLoading = false;
        console.log(error);
      }
    },
    // 确认
    onConfirm() {
      this.req_payRecharge();
    },
    // webScoket发送消息
    sendMessage(txt) {
      this.webSocket.send(txt);
    },
    // webScoket异常重连
    resetConnect() {
      this.connectCount = this.connectCount || 0;
      if (!this.webSocketInterval) {
        this.webSocketResetInterval = setInterval(() => {
          this.connectCount += 1;
          if (this.connectCount <= 5) {
            this.startSocket();
            this.webSocketResetInterval &&
              clearInterval(this.webSocketResetInterval);
          }
        }, 1000);
      }
    },
    // 开启webScoket
    startSocket() {
      this.messageTotal = 0;
      this.webSocket = new WebSocket(
        `${WEBSOCKET_URL}/bjweb/webSocket/pay${this.orderNo}/${this.token}`
      );
      // 接收消息事件
      this.webSocket.onmessage = (e) => {
        if (e.data === "open:suc") {
          this.sendMessage("start");
          this.heartInterval = setInterval(() => {
            if (this.messageTotal === 10) {
              this.sendMessage("heart");
              this.messageTotal = 0;
            }
            this.messageTotal += 1;
          }, 1000);
        }
        if (e.data.includes("msg:")) {
          const message = e.data.split("msg:")[1];
          this.messageTotal = 0;
          const info = JSON.parse(message);
          if (info != null) {
            if (info.result === "true") {
              this.clearSocket();
              this.qrCodeModalVisibility = false;
              this.$Message.success("充值成功！");
              this.form.amount = "";
              this.ACT_AMOUNT_INFO();
            }
          }
        }
        if (e.data.includes("rec:stop")) {
          this.webSocket.close();
        }
      };

      // 连接失败事件
      this.webSocket.onerror = () => {
        this.resetConnect();
      };
    },
    // 清空socket
    clearSocket() {
      if (this.webSocket) {
        this.sendMessage("stop");
        this.heartInterval && clearInterval(this.heartInterval);
        this.webSocketResetInterval &&
          clearInterval(this.webSocketResetInterval);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.back-info {
  display: flex;
  .bank-icon {
    width: 290px;
    margin-right: 20px;
  }
  .back-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .tips {
    margin-top: 10px;
    color: #f85a36;
  }
}
.section {
  background-color: #2c2e2f;
  border-radius: 8px;
  padding: 32px;
  color: #fff;
  .title {
    color: #fff;
    .price {
      color: #f85a36;
      font-size: 30px;
    }
  }
  .name {
    color: #fff;
  }
}
.cz-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 80px;
  background-color: transparent;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #fff;
  .text {
    font-size: 18px;
    margin-left: 20px;
  }
}
.actives {
  border: 1px solid #f85a36;
}
.cz-icon {
  width: 46px;
  height: 46px;
}
.wx-icon {
  width: 46px;
  height: 46px;
}
</style>
